
import _ from 'lodash'

import http from '../../../../lib/http'

export const MEDICATION_INTERACTIONS = 'MEDICATION_INTERACTIONS'
export const MEDICATION_INTERACTIONS_SUCCESS =
  'MEDICATION_INTERACTIONS_SUCCESS'
export const MEDICATION_INTERACTIONS_FAILURE =
  'MEDICATION_INTERACTIONS_FAILURE'
export const MEDICATION_ISSUE_CHECK = 'MEDICATION_ISSUE_CHECK'

export const medicationInteractionSuccess = data => ({
  type: MEDICATION_INTERACTIONS_SUCCESS,
  interactions: data.interactions
})

export const interactions = () => ({
  type: MEDICATION_INTERACTIONS
})

export const medicationsCheck = () => ({
  type: MEDICATION_ISSUE_CHECK
})

export const getInteractions = medications => dispatch => {
  dispatch(interactions())
  const ids = _.compact(medications.map(m => m.coding.code))

  if (ids && ids.length >= 2) {
    return http
      .getRequest(`/terminology/drugbank/interactions?ids=${ids.join(',')}`)
      .then(response => {
        dispatch(medicationInteractionSuccess({ interactions: response }))
      })
  }

  dispatch({
    type: 'UPDATE_INTERACTIONS',
    interactions: []
  })
}
